import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { Map } from "@vis.gl/react-google-maps";

interface ShipmentMapProps {
  pickupLocation: { lat: number; lng: number };
  deliveryLocation: { lat: number; lng: number };
}

export function ShipmentMap({
  pickupLocation,
  deliveryLocation,
}: ShipmentMapProps) {
  return (
    <div className="w-full h-full">
      <Map
        defaultCenter={{ lat: pickupLocation.lat, lng: pickupLocation.lng }}
        defaultZoom={11}
        mapId={"3667d2e0a1e93d2b"}
        gestureHandling="greedy"
        disableDefaultUI
        style={{
          width: "100%",
          height: "100%",
          minHeight: "600px",
          borderRadius: "8px",
        }}
      >
        <AdvancedMarker position={pickupLocation}>
          <div className="bg-blue-500 text-white px-2 py-1 rounded text-sm">
            Pickup
          </div>
        </AdvancedMarker>
        <AdvancedMarker position={deliveryLocation}>
          <div className="bg-green-500 text-white px-2 py-1 rounded text-sm">
            Delivery
          </div>
        </AdvancedMarker>
      </Map>
    </div>
  );
}
